(function (w) {
	'use strict';

	var mxFormControlBase = function (controller, templateUrl, template) {
		var directive = {
			restrict: 'E',
			require: {
				ngModel: '?^ngModel',
				mxForm: '?^mxForm',
				mxUiAccessibility: '?^mxUiAccessibility',
				mxContainerCtrl: '?^^mxContainer',
			},
			templateUrl: templateUrl,
			template: template,
			controller: controller,
			controllerAs: 'vm',
			scope: {},
			bindToController: {
				name: '@',
				label: '@',
				ariaLabel: '@',
				hint: '@',
				disabled: '=?',
				readOnly: '=?',
				ignoreReadonly: '<?',
				model: '=?ngModel',
				onChange: '&',
				showHints: '=?',
				setValidity: '=?',
				customValidation: '<',
			},
		};

		directive.link = function (scope, element, attrs, ctrls) {
			var vm = scope[directive.controllerAs];
			vm.controlNgModel = ctrls.ngModel;
			var form = ctrls.mxForm || {};
			var mxUiAccessibility = ctrls.mxUiAccessibility || {};

			Object.defineProperty(vm, '_readOnly', {
				get: function () {
					return !vm.ignoreReadonly && (vm.readOnly || form.readOnly || mxUiAccessibility.readOnly);
				},
			});

			Object.defineProperty(vm, '_disabled', {
				get: function () {
					return vm.disabled || form.disabled || mxUiAccessibility.disabled;
				},
			});

			Object.defineProperty(vm, '_showHints', {
				get: function () {
					return vm.showHints;
				},
				set: function (value) {
					vm.showHints = value;
				},
			});

			Object.defineProperty(vm, 'hintPlainText', {
				get: () => $('<div>' + (vm.hint || '').replace(/<h(\d)>/gi, '\n\n$&').replace(/<\/h(\d)>/gi, '$&\n') + '</div>').text(),
			});

			if (vm.controlNgModel) {
				vm.controlNgModel.label = vm.label;
				vm.controlNgModel.mxErrorMessages = {};
				vm.controlNgModel.$$parentForm.mxErrorMessages = vm.controlNgModel.$$parentForm.mxErrorMessages || {};
			}

			if (vm.customValidation) {
				vm.setCustomValidity(vm.customValidation);
			}

			if (ctrls.mxContainerCtrl) {
				ctrls.mxContainerCtrl.registerChild(scope);
			}
		};

		return directive;
	};

	var mxFormControlControllerBase = function ($timeout) {
		var vm = this;
		vm.name = vm.name || 'c' + mx.components.Utils.guid();
		vm.internalName = vm.name + '_int';
		vm.msgElemId = mx.components.Utils.genElemId('mx-aria-msg-');

		setValue(vm.model, true);

		vm.showHints = true;

		var _isValid = true;
		var _isFocused = false;
		vm.validationStatus = function (isInvalid) {
			if (_isValid === isInvalid) {
				_isValid = !isInvalid;
				vm.showingHints();
			}
		};

		vm.setValidity = function (formValidation, isValid) {
			vm.controlNgModel.$setValidity(formValidation, isValid);
		};

		vm.setCustomValidity = function (value) {
			if (typeof vm.controlNgModel !== 'object' || vm.controlNgModel === null) {
				return;
			}
			const attributeName = vm.controlNgModel.$$attr.ngModel.split('.').pop();
			vm.controlNgModel.mxErrorMessages[attributeName] = value.ErrorMessage;
			vm.controlNgModel.$$parentForm.mxErrorMessages[attributeName] = value.ErrorMessage;

			vm.setValidity(attributeName, value.IsValid);
		};

		Object.defineProperty(vm, 'model', {
			get: function () {
				return vm._model;
			},
			set: setValue,
		});

		var customValidation = vm.customValidation;
		Object.defineProperty(vm, 'customValidation', {
			get: function () {
				return customValidation;
			},
			set: function (value) {
				customValidation =
					value && value.hasOwnProperty('IsValid') && value.hasOwnProperty('ErrorMessage')
						? value
						: {
								IsValid: true,
								ErrorMessage: '',
						  };
				vm.setCustomValidity(customValidation);
			},
		});

		function setValue(value, skipEvent) {
			if (value === vm._model) {
				return;
			}
			if (typeof vm.onValueChanging === 'function') {
				value = vm.onValueChanging(value);
			}
			var oldVal = vm._model;
			vm._model = value;

			if (!skipEvent && oldVal !== value && vm.onChange) {
				//We must wait next digest circle for get actual value in the onChange
				if ($timeout) {
					$timeout(function () {
						vm.onChange();
					});
				} else {
					vm.onChange();
				}
			}
		}

		vm.showingHints = function (isFocus) {
			if (angular.isDefined(isFocus)) {
				_isFocused = isFocus;
			}

			var _toShowHints = !!vm.hint && (!!_isFocused || !!_isValid);
			if ($timeout) {
				$timeout(function () {
					vm._showHints = _toShowHints;
				});
			} else {
				vm._showHints = _toShowHints;
			}
		};

		vm.setHintHandlers = function (inputEl) {
			inputEl
				.on('focus', () => {
					vm.showingHints(true);
				})
				.on('blur', () => {
					vm.showingHints(false);
				});
		};
	};

	w.mx = w.mx || {};
	w.mx.components = w.mx.components || {};
	w.mx.components.FormControlBase = mxFormControlBase;
	w.mx.components.FormControlControllerBase = mxFormControlControllerBase;
})(window);
